import styled from 'styled-components';
export const PartnerBlock = styled.article`
    border: 1px solid ${props => props.theme.partnerBlockBorderColor};
    border-radius: 10px;
    padding: 0 15px 20px;
    overflow: hidden;
    .type {
        width: 120%;
        border-bottom: 1px solid ${props => props.theme.partnerBlockBorderColor};
        padding: 10px 0;
        text-transform: uppercase;
        font-weight: ${props => props.theme.regularWeight};
        font-size: 12px;
        margin: 0 -20px;
        display: flex;
        justify-content: center;
        .picto {
            margin: 0 10px 0 0;
        }
    }
    hr {
        background-color: ${props => props.theme.partnerBlockBoderColor};
        color: ${props => props.theme.partnerBlockBoderColor};
        margin: 0 10px;
        width: 168px;
        width: calc(100% - 20px);
        box-sizing: border-box;
        overflow: hidden;
    }
    .blp-reduction {
        margin: 25px 0 20px;
        height: auto;
        min-height: 70px;
        justify-content: space-around;

        &.noDiscount {
            min-height: 23px;
        }

        .valeur {
            font-size: 20px;
            margin: 5px 0;
            line-height: 1;
            color: ${props => props.theme.partnerOfferMain};
            font-weight: ${props => props.theme.partnerOfferMainTextWeight};
            strong {
                font-weight: ${props => props.theme.partnerOfferMainValueWeight};
            }
        }

        .aulieu {
            color: ${props => props.theme.partnerOfferSecond};
            font-weight: ${props => props.theme.partnerOfferSecondWeight};
        }

        .nocashback {
            color: ${props => props.theme.black};
        }

        .small {
            font-size: 12px;
        }
    }
    .bt-conteneur {
        color: ${props => props.theme.partnerOfferSecond};
        margin: auto 0 0;
        .bt {
            margin: auto 10px;
            width: 168px;
            width: calc(100% - 20px);
        }
    }
    .ebonValidity {
        margin-top: 10px;
        font-size: 12px;
    }
    .immediately {
        font-family: ${props => props.theme.fontStackSpecial};
        font-weight: ${props => props.theme.boldWeight};
        font-size: 15px;
    }
    .ebonCumul {
        margin-top: 5px;
        width: 100%;
        color: ${props => props.theme.secondary};
        font-size: 12px;
        font-weight: ${props => props.theme.boldWeight};
        &.noCb {
            color: ${props => props.theme.lightGrey};
            font-family: ${props => props.theme.fontStackCommon};
            font-weight: ${props => props.theme.regularWeight};
        }
    }

    .pictoContainer {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        position: relative;

        img {
            margin-left: 3px;
            position: absolute;
            top: -20px;
            right: -15px;
        }
    }

    .pictoContainer > span {
        padding: 10px 10px;
    }

    @media screen and (max-width: ${props => props.theme.large}) {
        & {
            max-width: 280px;
            margin-left: auto;
            margin-right: auto;
        }
    }
    @media screen and (min-width: ${props => props.theme.medium}) and (max-width: ${props =>
            props.theme.large}) {
        [class*='grid-4'] & {
            max-width: none;
        }
        .logo {
            width: auto;
            height: auto;
        }
        .bt {
            font-size: 11px;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/partner/PartnerBlockComponentStyle.js